export default __webpack_public_path__ + "static/media/g10.fb0b889d.jpg";